export const loadersCommonProps = {

  /**
   * The loader diameter in px.
   */
  diameter: {
    type: Number,
    default: 48,
  },

  /**
   * The loader border size in px.
   */
  border: {
    type: Number,
    default: 4,
  },

  /**
   * The loader border color.
   */
  borderColor: {
    type: String,
    default: '#3598dc',
  },

  /**
   * The loader background circle color.
   */
  backgroundColor: {
    type: String,
    default: '#c8cdda',
  },

  /**
   * The percentage of the filled bar.
   */
  percentage: {
    type: Number,
    default: 75,
  },
};
